export default "__VITE_ASSET__C1vJ6Doi__"